import * as React from 'react';
import {TextareaHTMLAttributes} from 'react';

import {Label} from '@shared/ui/Label';

import {TextareaContainer, TextareaElem} from './styled';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    hasError?: boolean;
    label?: string;
    formFieldName?: string;
    isRequired?: boolean;
}

export function Textarea(props: Props) {
    const {className, label, disabled = false, hasError, isRequired = false, ...otherProps} = props;

    return (
        <TextareaContainer className={className}>
            <Label text={label} hasError={hasError} isRequired={isRequired}>
                <TextareaElem hasError={hasError} disabled={disabled} {...otherProps} />
            </Label>
        </TextareaContainer>
    );
}
